// Deflect Analytics endpoints, one per section.
import { request } from "../../../Services/Api"
import { getReceiptLookups } from "../../ReceiptPage/api/services"

export const getDeflectKpis = (params) =>
  request.api.get("/consumer-clarity/analytics/kpis/", params)

export const getDeflectTrend = (params) =>
  request.api.get("/consumer-clarity/analytics/trend/", params)

export const getDeflectQueue = (params) =>
  request.api.get("/consumer-clarity/analytics/queue/", params)

export const getDeflectFlow = (params) =>
  request.api.get("/consumer-clarity/analytics/flow/", params)

export const getDeflectByChannel = (params) =>
  request.api.get("/consumer-clarity/analytics/by-channel/", params)

export const getDeflectByCountry = (params) =>
  request.api.get("/consumer-clarity/analytics/by-country/", params)

export const getDeflectByProgram = (params) =>
  request.api.get("/consumer-clarity/analytics/by-program/", params)

export const getDeflectMatchRateMatrix = (params) =>
  request.api.get("/consumer-clarity/analytics/match-rate-matrix/", params)

export const getDeflectRepeatCardholders = (params) =>
  request.api.get("/consumer-clarity/analytics/repeat-cardholders/", params)

export const getDeflectChannelTrends = (params) =>
  request.api.get("/consumer-clarity/analytics/channel-trends/", params)

// Receipt's dashboard/lookups/ takes one program or "all" (a CSV of both is a 400) and the window
// as a single "<from>,<to>" datetime pair, the way the Receipt filter bar sends it.
export const getDeflectLookups = ({
  start_date,
  end_date,
  program,
  descriptor = [],
  ...params
}) => {
  const defined = Object.entries(params).filter(([, value]) => value != null)
  const query = new URLSearchParams({
    ...Object.fromEntries(defined),
    program: program && !program.includes(",") ? program : "all",
    ...(start_date && end_date ? { date: `${start_date}T00:00:00Z,${end_date}T23:59:59Z` } : {})
  })
  descriptor.forEach((value) => query.append("descriptor", value))

  return getReceiptLookups(query)
}

export const getDeflectLookupDescriptors = (params) =>
  request.api.get("/consumer-clarity/dashboard/lookup-descriptors/", params)
